import "core-js/stable";

import { checkBasicEnviro } from "./init/checkBasicEnviro";
import { initBasicErrorBox } from "./init/initBasicErrorBox";
import { initSentry } from "./init/initSentry";
import { loadGameScripts } from "./init/loadGameScripts";

(async function init() {
	await initSentry();
	await initBasicErrorBox();
	await checkBasicEnviro();
	await loadGameScripts();
})();

